import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("rescigo_token");
    if (!token) {
      setUser(false);
      setBootstrapped(true);
      return;
    }
    api.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setBootstrapped(true));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.requires_otp) {
      // 2FA flow — caller (AdminEntry) handles the OTP step itself.
      return { requires_otp: true, ...r.data };
    }
    localStorage.setItem("rescigo_token", r.data.access_token);
    localStorage.setItem("rescigo_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  // Used by AdminEntry to commit the session after the OTP step succeeds.
  const setUserAfterLogin = (u) => setUser(u);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("rescigo_token");
    localStorage.removeItem("rescigo_user");
    setUser(false);
    // Per access-control rule: /adentry is only reachable by direct URL entry.
    // After logout, drop the user back on the marketing home.
    window.location.href = "/";
  };

  const can = (roles) => {
    if (!user) return false;
    if (!roles || roles.length === 0) return true;
    return roles.includes(user.role);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, bootstrapped, can, setUserAfterLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be within AuthProvider");
  return ctx;
}
